import { useEffect, useState } from "react";
import crossbtn from '../home/images/close-btn.svg';
import axios from 'axios';
import historybtn from '../assets/history.png';
import img0 from '../assets/number/0.png';
import img1 from '../assets/number/1.png';
import img2 from '../assets/number/2.png';
import img3 from '../assets/number/3.png';
import img4 from '../assets/number/4.png';
import img5 from '../assets/number/5.png';
import img6 from '../assets/number/6.png';
import img7 from '../assets/number/7.png';
import img8 from '../assets/number/8.png';
import img9 from '../assets/number/9.png';
import colon from '../assets/number/colon.png';
import indicatorred from '../assets/x-red.png';
import round1 from '../assets/round1.png';
import round2 from '../assets/round2.png';
import round3 from '../assets/round3.png';
import blankpng from '../assets/blank.png';
import PropTypes from 'prop-types';

const Timerbox = (props) => {
    var [remainingTime, setRemainingTime] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [historydata, setHistorydata] = useState([]);
    useEffect(() => {
        if (remainingTime > 0) {
            let interval = setInterval(() => {
                setRemainingTime((prevTime) => prevTime + 1);
            }, 1000);

            if (props.strike === 10) {
                clearInterval(interval);
                setRemainingTime(0);
            }
            return () => clearInterval(interval);
        } else {
            setRemainingTime(1);
        }
    }, []);

    const formattedTime = `${Math.floor(remainingTime / 60).toString().padStart(2, '0')}:${(remainingTime % 60).toString().padStart(2, '0')}`;

    const gettoken = localStorage.getItem('token');
    const wordgameId = localStorage.getItem('gameId');
    const getfreepai = localStorage.getItem('apitype');

    const tournamentlocalid = localStorage.getItem('tournamentId');
    const wordHistoryScore = async () => {
        if (getfreepai === "free") {
            setHistorydata(null);
        } else {
            await axios.get(`${process.env.B_APP_API_URL}/lockitapi/Word/GetWordHistory?tournamentId=${tournamentlocalid}`, {
                headers: {
                    Authorization: `Bearer ${gettoken}`
                }
            }).then((response) => {

                console.log("============================================");
                console.log("TIMER -- GET WORD HISTORY");
                console.log("============================================");
                console.log("Token - from localStorage.getItem('token'): ", gettoken);
                console.log("Word Game Id (from localStorage.getItem('gameId')): ", wordgameId);
                console.log("Get Free API (from localStorage.getItem('apitype')): ", getfreepai);
                console.log("Tournament Local ID (from localStorage.getItem('tournamentId')): ", tournamentlocalid);
                console.log("Headers: Bearer ", gettoken);
                console.log("Response: ", response);
                setHistorydata(response?.data?.data)
            }).catch((err) => {
                console.log(err, "error");
            })
        }
    };

    useEffect(() => {
        if (wordgameId)
            wordHistoryScore();
    }, [showModal]);

    let imgArray = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9];
    let roundArray = [round1, round2, round3];
    let invalidArray = [indicatorred, indicatorred, indicatorred];

    return (
        <>
            <div className="timerbox">
                <div className="level-box">
                    <button className="btn" type="button">
                        <img src={roundArray[props.round - 1]} draggable={false} />
                    </button>

                    {(props.invalidmsg) ?
                        <div className="x-indicate">
                            <img src={invalidArray[props.invalidmsg - 1]} draggable={false} />
                            <img src={invalidArray[props.invalidmsg - 2]} draggable={false} />
                            <img src={invalidArray[props.invalidmsg - 3]} draggable={false} />
                        </div>
                        : <div className="x-indicate blankdiv"><img src={blankpng} /></div>}
                </div>
                <div className="timer-counter" draggable={false}>
                    <img src={imgArray[formattedTime.split('')[0]]} draggable={false} />
                    <img src={imgArray[formattedTime.split('')[1]]} draggable={false} />
                    <img src={colon} className="colon" draggable={false} />
                    <img src={imgArray[formattedTime.split('')[3]]} draggable={false} />
                    <img src={imgArray[formattedTime.split('')[4]]} draggable={false} />
                </div>
                <div className="historybox">
                    <button className="btn" type="button" onClick={() => setShowModal(true)}>
                        <img src={historybtn} alt="" draggable={false} />
                    </button>
                </div>
            </div>

            {
                showModal ?
                    <div className='wordModal main-worModal'>
                        <div className={`modal ${showModal ? 'show' : ''}`} onClick={() => setShowModal(false)}>
                            <div className="modal-content" onClick={e => e.stopPropagation()}>
                                <div className="modal-header">
                                    <h4 className="modal-title">Word History</h4>
                                    <button className="close-button" onClick={() => setShowModal(false)}><img src={crossbtn} alt="crossbtn" /></button>
                                </div>
                                <div className="modal-body">

                                    {historydata != null ?
                                        <div className="modalContent">
                                            <div className="contHeading">
                                                <h3>Points</h3>
                                            </div>
                                            <div className="wordName">
                                                <h3>Words Name</h3>
                                            </div>
                                        </div> : ""
                                    }

                                    {historydata != null ?
                                        (
                                            historydata?.map((item, i) => {
                                                return (
                                                    <div className="modalContent modal-score" key={i}>
                                                        <div className="point-box">
                                                            <h3>{item.score}</h3>
                                                        </div>
                                                        <div className="word-box">
                                                            <h3>{item.word}</h3>
                                                        </div>
                                                    </div>
                                                )
                                            })) :
                                        <div className="feature-heading">
                                            <h3>Feature not available in practice mode</h3>
                                        </div>
                                    }

                                </div>
                                <div className="modal-footer">
                                    <button onClick={() => setShowModal(false)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''
            }
        </>
    );
};

Timerbox.propTypes = {
    strike: PropTypes.number.isRequired,
    round: PropTypes.number.isRequired,
    invalidmsg: PropTypes.number
};

export default Timerbox;